import React, { useState, useEffect } from "react";
import * as Utils from "../utils/Utils.js";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import ShareIcon from "../assets/icons/share.svg";
import { getBrowserScrollbarWidth } from "../utils/Utils.js";

const ShareButton = (props) => {
  const [title, setTitle] = useState(props.title);
  const [banner, setBanner] = useState(props.banner);
  const [link, setLink] = useState(props.link || window.location.href);
  const [clicked, setClicked] = useState(false);
  const [open, setOpen] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  useEffect(() => {
    setTitle(props.title);
    setBanner(props.banner);
    setLink(props.link || window.location.href);
  }, [props.title, props.banner, props.link]);

  useEffect(() => {
    if (clicked) {
      if (Utils.isMobileDevice() && navigator.canShare) {
        let shareData = { title, url: link };
        if (navigator.canShare(shareData)) {
          navigator.share(shareData);
        } else {
          showModal();
        }
      } else {
        showModal();
      }
    }
    setClicked(false);
  }, [clicked]);

  const setInlineState = (e) => {
    let item = $(e.target).closest("._account_order_link");
    let title = item.find("._account_order_event_title").text().trim();
    let banner = item.find("._account_order_image").attr("src");
    let link = window.location.origin + item.attr("href");

    setTitle(title);
    setBanner(banner);
    setLink(link);
  };

  const handleOpen = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (props.inline) setInlineState(e);

    setClicked(true);
  };

  const showModal = () => {
    setOpen(true);
    const scrollbarWidth = getBrowserScrollbarWidth();
    document.documentElement.style.overflow = "hidden";
    document.querySelector("body").style.marginRight = `${scrollbarWidth}px`;
    toggleIntercomVisibility(false);
  };

  const closeModal = () => {
    setOpen(false);
    closeSnackbar();
    document.documentElement.style.overflow = "auto";
    document.querySelector("body").style.marginRight = "0";
    toggleIntercomVisibility(true);
  };

  const toggleIntercomVisibility = (isVisible) => {
    const intercom = document.getElementsByClassName(
      "intercom-lightweight-app"
    )[0];
    if (Utils.exists(intercom)) {
      intercom.style.visibility = isVisible ? "visible" : "hidden";
    }
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(link);
    setOpenSnackbar(true);
  };

  const closeSnackbar = () => {
    setOpenSnackbar(false);
  };

  return (
    <>
      <div
        style={{
          width: props.inline ? 24 : 32,
          height: props.inline ? 24 : 32,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 80,
          background: "#FFFFFF",
          cursor: "pointer",
        }}
        onClick={handleOpen}
      >
        <ShareIcon />
      </div>
      <Modal open={open} onClose={closeModal}>
        <div>
          <div className="r_shareOverlayFlow" onClick={closeModal}></div>
          <Box className="r_shareBox">
            <a className="r_closeShare">
              <span></span>
              <img
                id="r_closeShareImg"
                className="r_closeShareImg"
                onClick={closeModal}
                src={
                  "https://www.more.com/Site/images/icons/eventpage/closeMuiModal.svg"
                }
                alt="Close"
              />
            </a>
            <div className="r_shareMainInfo">
              {banner && (
                <img className="r_shareBanner" src={banner} alt="Banner" />
              )}
              <span className="r_shareTitle">{title}</span>
              <span className="r_shareMessage">
                {playdetailsv2_resources.ShareText}
              </span>
            </div>
            <div className="r_shareOptions">
              <div className="r_shareCol">
                <a className="r_shareOption" onClick={copyToClipboard}>
                  <img
                    className="r_shareOptionImage"
                    src={
                      Tickets.appPath +
                      "Site/images/icons/eventpage/copyLink.svg"
                    }
                    alt="Copy Link"
                  />
                  {playdetailsv2_resources.CopyLink}
                </a>
                <a
                  className="r_shareOption"
                  target="_blank"
                  rel="noopener noreferrer"
                  href={"sms:?&body=" + encodeURIComponent(link)}
                >
                  <img
                    className="r_shareOptionImage"
                    src={
                      Tickets.appPath + "Site/images/icons/eventpage/sms.svg"
                    }
                    alt="Share as message"
                  />
                  Share as message
                </a>
                <a
                  className="r_shareOption"
                  target="_blank"
                  rel="noopener noreferrer"
                  href={
                    "http://www.facebook.com/sharer.php?u=" +
                    encodeURIComponent(link)
                  }
                >
                  <img
                    className="r_shareOptionImage"
                    src={
                      Tickets.appPath +
                      "Site/images/icons/eventpage/facebook.svg"
                    }
                    alt="Facebook"
                  />
                  Facebook
                </a>
                <a
                  className="r_shareOption"
                  href={"fb-messenger://share?link=" + encodeURIComponent(link)}
                >
                  <img
                    className="r_shareOptionImage"
                    src={
                      Tickets.appPath +
                      "Site/images/icons/eventpage/messenger.svg"
                    }
                    alt="Messenger"
                  />
                  Messenger
                </a>
              </div>
              <div className="r_shareCol">
                <a
                  className="r_shareOption twitter-share-button"
                  target="_blank"
                  rel="noopener noreferrer"
                  href={
                    "https://twitter.com/intent/tweet?text=" +
                    encodeURIComponent(link)
                  }
                >
                  <img
                    className="r_shareOptionImage"
                    src={
                      Tickets.appPath +
                      "Site/images/icons/eventpage/twitterX.svg"
                    }
                    alt="X"
                  />
                  X
                </a>
                <a
                  className="r_shareOption"
                  target="_blank"
                  rel="noopener noreferrer"
                  href={"viber://forward?text=" + encodeURIComponent(link)}
                >
                  <img
                    className="r_shareOptionImage"
                    src={
                      Tickets.appPath + "Site/images/icons/eventpage/viber.svg"
                    }
                    alt="Viber"
                  />
                  Viber
                </a>
                <a
                  className="r_shareOption"
                  role="link"
                  data-action="share/whatsapp/share"
                  target="_blank"
                  rel="noopener noreferrer"
                  href={"whatsapp://send?text=" + encodeURIComponent(link)}
                >
                  <img
                    className="r_shareOptionImage"
                    src={
                      Tickets.appPath +
                      "Site/images/icons/eventpage/whatsapp.svg"
                    }
                    alt="WhatsApp"
                  />
                  Whatsapp
                </a>
              </div>
            </div>
            <Snackbar
              open={openSnackbar}
              autoHideDuration={1200}
              onClose={closeSnackbar}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              TransitionProps={{
                onEnter: (node) => {
                  node.style.transition = "opacity 0.5s";
                  node.style.opacity = "1";
                },
              }}
              sx={{
                height: "32px",
              }}
            >
              <Alert
                severity="success"
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "#1F1C43",
                  color: "#FFF",
                  fontSize: "14px",
                  borderRadius: "8px",
                  "& .MuiAlert-icon": {
                    color: "#FFF",
                  },
                  marginBottom: "40px",
                }}
              >
                {playdetailsv2_resources.CopiedToClipboard}
              </Alert>
            </Snackbar>
          </Box>
        </div>
      </Modal>
    </>
  );
};

export default ShareButton;
